// src/store/useAuthStore.js
import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { NAV_CONFIG, ROLE_HOME, FULL_ACCESS_ROLES } from "@/config/navigation";
import { getAuthStorage, setRememberFlag, clearAuthStorage } from "@/utils/authStorage";

// ── Fuente única de sesión/rol ────────────────────────────────
// src/utils/api_backend.js sigue leyendo/limpiando access_token y
// user_role directo de storage en su interceptor de axios (vía el mismo
// helper authStorage.js), así que este store escribe esas mismas claves
// además de su estado reactivo (no usa el formato serializado de
// pinia-plugin-persistedstate).
export const useAuthStore = defineStore("auth", () => {
  const initialStorage = getAuthStorage();
  const token = ref(initialStorage.getItem("access_token") || "");
  const refreshToken = ref(initialStorage.getItem("refresh_token") || "");
  const role = ref(initialStorage.getItem("user_role") || "user");
  const userName = ref(initialStorage.getItem("user_name") || "");
  const userApellido = ref(initialStorage.getItem("user_apellido") || "");

  const roleLabel = computed(() => NAV_CONFIG.roleLabels[role.value] ?? role.value);
  const homeRoute = computed(() => ROLE_HOME[role.value]);
  const isFullAccess = computed(() => FULL_ACCESS_ROLES.includes(role.value));

  // `remember` decide si la sesión sobrevive al cerrar el navegador
  // (localStorage) o solo dura la pestaña actual (sessionStorage).
  function setSession({ access, refresh, user }, remember = true) {
    setRememberFlag(remember);
    const storage = getAuthStorage();

    token.value = access;
    refreshToken.value = refresh;
    role.value = user.role;
    userName.value = user.nombre;
    userApellido.value = user.apellido;

    storage.setItem("access_token", access);
    storage.setItem("refresh_token", refresh);
    storage.setItem("user_role", user.role);
    storage.setItem("user_name", user.nombre);
    storage.setItem("user_apellido", user.apellido);
  }

  function logout() {
    token.value = "";
    refreshToken.value = "";
    role.value = "user";
    userName.value = "";
    userApellido.value = "";
    clearAuthStorage();
  }

  return {
    token,
    refreshToken,
    role,
    userName,
    userApellido,
    roleLabel,
    homeRoute,
    isFullAccess,
    setSession,
    logout,
  };
});
